import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class SirvoEmpresasRoute extends Route {
  @service store;

  model() {
    return this.store.query('empresa', {
      filter: {
        fechaInicio: '2025-08-01T00:00:00-06:00',
        fechaFin: '2025-08-31T23:59:59-06:00',
      },
    });
  }
}
